import React, { forwardRef, useImperativeHandle } from 'react';
import { MapContainer, TileLayer, LayersControl, FeatureGroup, Circle, Marker, Tooltip, ImageOverlay, Pane } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import L, { latLng, latLngBounds } from 'leaflet';
import GeoJson from './GeoJson';
import { LinearProgress } from '@mui/material';
import { EditControl } from 'react-leaflet-draw';
import drawLocales from 'leaflet-draw-locales';
import axios from 'axios';
import { getMarkerIcon } from './MarkerIcon';
drawLocales('ru');
const { BaseLayer } = LayersControl;
// Единая стартовая точка продукта. Карта не должна зависеть от IP или
// геолокации браузера: они нередко определяются неточно и уводят пользователя
// в другую страну при первом открытии.
export const UST_KAMENOGORSK_CENTER = [49.9714, 82.6059];
const OpenStreetMaps = forwardRef((props, ref) => {
    const map = React.useRef(null);
    const geo = React.useRef(null);
    const feature = React.useRef(null);
    const containerRef = React.useRef(null);
    const [load, setLoad] = React.useState(false);
    const [json, setJson] = React.useState(null);
    const [center, setCenter] = React.useState(() => { var _a; return latLng((_a = props.center) !== null && _a !== void 0 ? _a : UST_KAMENOGORSK_CENTER); });
    const [stantions, setStantions] = React.useState([]);
    const [filterId, setFilterId] = React.useState([]);
    useImperativeHandle(ref, () => ({
        setFly: Fly,
        setUrl: setUrl,
        invalidateSize: () => {
            var _a;
            (_a = map.current) === null || _a === void 0 ? void 0 : _a.invalidateSize();
        },
        setFilterId: setFilterId,
        setEditebleObject: setEditebleObject
    }));
    // `MapContainer` читает `center` только при создании. Синхронизируем
    // переданный центp явно для экранов, где он меняется (например, выбор
    // компании при создании поля), и возвращаемся к Усть-Каменогорску, когда
    // конкретный центр не задан.
    React.useEffect(() => {
        var _a;
        const nextCenter = latLng((_a = props.center) !== null && _a !== void 0 ? _a : UST_KAMENOGORSK_CENTER);
        setCenter((currentCenter) => currentCenter.equals(nextCenter) ? currentCenter : nextCenter);
    }, [props.center]);
    React.useEffect(() => {
        const node = containerRef.current;
        if (!node)
            return;
        const resizeObserver = new ResizeObserver(() => {
            var _a;
            (_a = map.current) === null || _a === void 0 ? void 0 : _a.invalidateSize();
        });
        resizeObserver.observe(node);
        // Несколько отложенных вызовов на разных временных горизонтах —
        // страховка от того, что при первой отрисовке контейнер ещё не
        // получил финальный размер (шрифты/иконки MUI могут чуть сдвинуть
        // высоту хедера уже после первого invalidateSize()).
        const raf = window.requestAnimationFrame(() => {
            var _a;
            (_a = map.current) === null || _a === void 0 ? void 0 : _a.invalidateSize();
        });
        const timer100 = window.setTimeout(() => { var _a; return (_a = map.current) === null || _a === void 0 ? void 0 : _a.invalidateSize(); }, 100);
        const timer500 = window.setTimeout(() => { var _a; return (_a = map.current) === null || _a === void 0 ? void 0 : _a.invalidateSize(); }, 500);
        const onWindowLoad = () => { var _a; return (_a = map.current) === null || _a === void 0 ? void 0 : _a.invalidateSize(); };
        window.addEventListener('load', onWindowLoad);
        return () => {
            window.cancelAnimationFrame(raf);
            window.clearTimeout(timer100);
            window.clearTimeout(timer500);
            window.removeEventListener('load', onWindowLoad);
            resizeObserver.disconnect();
        };
    }, []);
    React.useEffect(() => {
        if (props.setJson) {
            props.setJson(json);
        }
    }, [json]);
    React.useEffect(() => {
    }, [filterId]);
    React.useEffect(() => {
        if (props.showStantions) {
            axios.get(`/${props.showStantions}/list`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${props.token}`
                }
            })
                .then((response) => {
                if (response.data) {
                    let st_items = response.data.items.map((st) => {
                        let s = {
                            coord: { lat: st.stantions_latitude_center, lng: st.stantions_longitude_center },
                            radius: st.stantions_radius,
                            name: st.stantions_name,
                            distance: 0,
                            type: st.type || 'meteo'
                        };
                        return s;
                    });
                    setStantions(st_items);
                }
            });
        }
    }, [, props.showStantions]);
    React.useEffect(() => {
        var _a, _b;
        (_a = map.current) === null || _a === void 0 ? void 0 : _a.setView(center, (_b = map.current) === null || _b === void 0 ? void 0 : _b.getZoom());
    }, [center]);
    const Fly = (x, zoom) => {
        var _a;
        setCenter(x);
        if (zoom) {
            (_a = map.current) === null || _a === void 0 ? void 0 : _a.setZoom(zoom);
        }
    };
    const setUrl = (x, y) => {
        var _a, _b, _c, _d, _e;
        if (x) {
            (_a = map.current) === null || _a === void 0 ? void 0 : _a.setView(y, (_b = map.current) === null || _b === void 0 ? void 0 : _b.getZoom());
        }
        else {
            (_c = map.current) === null || _c === void 0 ? void 0 : _c.setView(y, 13);
        }
        (_d = map.current) === null || _d === void 0 ? void 0 : _d.invalidateSize();
        (_e = geo.current) === null || _e === void 0 ? void 0 : _e.changeUrl(x, props.token, y);
    };
    // Создадим объекты для редактирования
    // Используется в агрохимическом анализе
    const setEditebleObject = (url) => {
        if (url) {
            axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${props.token}`
                }
            })
                .then((response) => {
                var _a, _b, _c;
                if (response.data && feature.current) {
                    ;
                    const mapBounds = latLngBounds(response.data.features.map(point => latLng(point.geometry.coordinates[1], point.geometry.coordinates[0])));
                    (_a = map.current) === null || _a === void 0 ? void 0 : _a.setMaxBounds(mapBounds);
                    (_b = map.current) === null || _b === void 0 ? void 0 : _b.setZoom(((_c = map.current) === null || _c === void 0 ? void 0 : _c.getMaxZoom()) - 1);
                    response.data.features.map((f, index) => {
                        const options = {
                            radius: 5,
                            stroke: false,
                            fillColor: 'rgb(255, 193, 7)',
                            fillOpacity: 1,
                            id: f.properties.id || 0
                        };
                        const circleMarker = L.circleMarker([f.geometry.coordinates[1], f.geometry.coordinates[0]], options);
                        const popupContent = `
                                <div>
                                    <h3>ID: ${f.properties.id || 0}</h3>
                                    <div>Азот: ${f.properties.nitrogen}</div>
                                    <div>Фосфор: ${f.properties.phosphorus}</div>
                                    <div>Калий: ${f.properties.potassium}</div>
                                </div>
                            `;
                        circleMarker.bindPopup(popupContent);
                        circleMarker.addTo(feature.current);
                    });
                }
            });
        }
    };
    const createdMap = (e) => {
        if (feature.current) {
            const drawnItems = feature.current._layers;
            if (Object.keys(drawnItems).length > 1) {
                Object.keys(drawnItems).forEach((layerid, index) => {
                    if (index > 0)
                        return;
                    const layer = drawnItems[layerid];
                    feature.current.removeLayer(layer);
                });
            }
        }
        buildJson(e);
    };
    const editedMap = (e) => {
        buildJson(e);
    };
    const deletedMap = (e) => {
        setJson(null);
    };
    const buildJson = (e) => {
        var _a;
        const { layerType, layer } = e;
        if (layerType == "polygon") {
            layer.getLatLngs().map((ll) => {
                let coodinates = ll.map((coord) => {
                    return [
                        coord.lat,
                        coord.lng
                    ];
                });
                let json = {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: coodinates,
                    },
                    properties: {},
                };
                setJson(json);
            });
        }
        // Одна точка — используется для указания координат пробы
        // агрохимического анализа при создании/редактировании
        if (layerType == "circlemarker") {
            const point = layer.getLatLng();
            let json = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [point.lng, point.lat],
                },
                properties: {},
            };
            setJson(json);
        }
        // Используется для редактирования Агрохимического анализа
        if (layerType == undefined && ((_a = props.editMode) === null || _a === void 0 ? void 0 : _a.remove) == false) {
            const { layers } = e;
            const markers = [];
            layers.getLayers().map((l) => {
                const id = l.options.id;
                const coords = l.getLatLng();
                markers.push({
                    id,
                    coords
                });
            });
            if (props.setEditResult !== undefined) {
                props.setEditResult(markers);
            }
        }
    };
    return (React.createElement("div", { ref: containerRef, style: { height: '100%', width: '100%', display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0, overflow: 'hidden' } },
        load === true && (React.createElement(LinearProgress, { color: "success" })),
        React.createElement(MapContainer, { center: center, zoom: 13, ref: map, whenReady: () => {
                window.setTimeout(() => {
                    var _a;
                    (_a = map.current) === null || _a === void 0 ? void 0 : _a.invalidateSize();
                }, 0);
            }, style: { width: '100%', height: '100%' } },
            props.editMode !== undefined && (React.createElement(FeatureGroup, { ref: feature },
                React.createElement(EditControl, Object.assign({}, {
                    position: 'topleft',
                    onCreated: createdMap,
                    onEdited: editedMap,
                    onDeleted: deletedMap,
                    draw: {
                        rectangle: false,
                        polyline: false,
                        circle: false,
                        circlemarker: props.editMode.circlemarker == true ? {
                            allowIntersection: false,
                            edit: true,
                            showLength: false,
                            metric: false,
                            feet: true,
                            showArea: false
                        } : false,
                        marker: false,
                        polygon: props.editMode.polygon == true ? {
                            allowIntersection: false,
                            edit: false,
                            showLength: true,
                            metric: true,
                            feet: false,
                            showArea: true
                        } : false
                    },
                    edit: {
                        edit: true,
                        remove: props.editMode.remove
                    },
                    onDrawStart: (e) => {
                        if (json !== null) {
                            return false;
                        }
                    }
                })))),
            React.createElement(LayersControl, null,
                React.createElement(BaseLayer, { checked: props.layerIndex == undefined || true, name: "ArcGIS World - \u0441\u043F\u0443\u0442\u043D\u0438\u043A" },
                    React.createElement(TileLayer, { url: 'https://{s}.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', maxZoom: 17, subdomains: ['server'] })),
                React.createElement(BaseLayer, { checked: props.layerIndex ? props.layerIndex == 1 : false, name: "Google map - \u0441\u043F\u0443\u0442\u043D\u0438\u043A" },
                    React.createElement(TileLayer, { url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&s=Ga&hl=ru', maxZoom: 20, subdomains: ['mt1', 'mt2', 'mt3'] })),
                React.createElement(BaseLayer, { checked: props.layerIndex ? props.layerIndex == 2 : false, name: "Map data \u00A9 OpenStreetMap - \u0440\u0435\u043B\u044C\u0435\u0444" },
                    React.createElement(TileLayer, { url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', maxZoom: 20 }))),
            stantions.length > 0 && (stantions.map((stantion, index) => {
                return (React.createElement(React.Fragment, null,
                    stantion.radius > 0 && (React.createElement(Circle, { key: `circle_${index}`, center: stantion.coord, radius: stantion.radius, color: 'rgba(254,231,218,89)', fillColor: 'rgba(254,231,218,89)' })),
                    React.createElement(Marker, { key: `marker_${index}`, icon: getMarkerIcon(stantion.type), position: stantion.coord },
                        React.createElement(Tooltip, { direction: "auto", offset: [0, 0], opacity: 1, permanent: props.tollTip == undefined ? false : props.tollTip }, stantion.name))));
            })),
            props.spectralRaster && (React.createElement(Pane, { name: "spectralRasterPane", style: { zIndex: 350 } },
                React.createElement(ImageOverlay, { url: props.spectralRaster.image, bounds: props.spectralRaster.bounds, opacity: 1, className: "spectral-class-raster" }))),
            React.createElement(GeoJson, { ref: geo, url: props.url, draw: props.draw, scipBorder: props.scipBorder, createBoundExtend: props.createBoundExtend, spectralRasterActive: Boolean(props.spectralRaster), token: props.token, filterId: filterId, setLoad: setLoad }),
            props.customControl)));
});
export default OpenStreetMaps;
